/***
 * Created on 2024/5/13
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import {
    CHINA, convertToQNAPLang,
    getAppCMSUrl,
    getCurrentDomainRegion, getPrivacyPolicyUrl, getQNAPUrl,
    getServiceStatusUrl,
    GLOBAL,
    SUPPORTED_LANGUAGES
} from "../../../service/common";
import Cookie from "js-cookie";
import RegionSwitchWarning from "../../dialog/region_switch_warning";
import {useTogglePopup} from "../../../hook/toggle_popup";

function MainLevelPanel({toggleLang, toggleSheet}) {
    const { t ,i18n} = useTranslation();
    const currentRegion = getCurrentDomainRegion();
    const [switchWarning, setSwitchWarning] = useState(false);
    const [regionNotMatchWarning, setRegionNotMatchWarning] = useState( !Cookie.get('regionNotMatchWarning') ? Cookie.get('client_region') !== currentRegion : false);
    const [switchToRegion, setSwitchToRegion] = useState(null);
    const {isShow, toggleAction, elemRef, setIsShow} = useTogglePopup({pinContent: true});

    const switchRegion = (region) => {
        if (currentRegion === region) return;

        if (region === CHINA) {
            window.location.host = window.acc_mf.common.APP_ACC_URL_CN.replace(/https?:\/\//i, '');
        }
        else {
            window.location.host = window.acc_mf.common.APP_ACC_URL.replace(/https?:\/\//i, '');
        }
        closeRegionSwitchWarning()
    }

    const onClickSetRegion = (region) => {
        if (currentRegion === region) return;

        setSwitchToRegion(region);
        if (!Cookie.get('noRegionSwitchWarning')) {
            setSwitchWarning(true);
        }
        else {
            switchRegion(region);
        }
        toggleSheet();
        // setIsShow(false);
    }

    const closeRegionSwitchWarning = () => {
        Cookie.set('noRegionSwitchWarning', true, {expires: 1, secure: true, sameSite: 'LAX'});
        setSwitchWarning(false);
    }

    const closeRegionMismatchWarning = () => {
        Cookie.set('regionNotMatchWarning', true, {expires: 1, secure: true, sameSite: 'LAX'});
        setRegionNotMatchWarning(false);
    }

    const onClickPreferredRegion = () => {
        setRegionNotMatchWarning(false);
        if (currentRegion === CHINA) {
            window.location.host = window.acc_mf.common.APP_ACC_URL_CN.replace(/https?:\/\//i, '');
        }
        else {
            window.location.host = window.acc_mf.common.APP_ACC_URL.replace(/https?:\/\//i, '');
        }
    }

    const onClick = (link) => {
        window.open(link, '_blank');
    }

    return (
        <div className="multi-level-sheet-content__panel">
            <div className="sheet-content">
                <ul className="sheet-list">
                    <li className="sheet-list__head">{t('@Language@')}</li>
                    <li className="sheet-list__section">
                        <ul>
                            <li className="sheet-list__item display-flex align-items-center cursor-pointer" onClick={()=>toggleLang(prev=> prev==='close' ? 'open' : 'close')}>
                                <span className="flex-1 min-w-0">
                                    {SUPPORTED_LANGUAGES.find(lang => lang.value === i18n.language)?.name}
                                </span>
                                <span className="sheet-list__item__mark--arrow-trigger flex-initial"></span>
                            </li>
                        </ul>
                    </li>

                    <li className="sheet-list__head">{t('@Region@')}</li>
                    <li className="sheet-list__section">
                        <ul>
                            <li className="sheet-list__item display-flex align-items-center cursor-pointer" onClick={() => onClickSetRegion(GLOBAL)}>
                                <span className="flex-1 min-w-0">{t('@Global@')}</span>
                                {currentRegion === GLOBAL && <span className="sheet-list__item__mark--checked flex-initial"></span>}
                            </li>
                            <li className="sheet-list__item display-flex align-items-center cursor-pointer"  onClick={() => onClickSetRegion(CHINA)}>
                                <span className="flex-1 min-w-0">{t('@China@')}</span>
                                {currentRegion === CHINA && <span className="sheet-list__item__mark--checked flex-initial"></span>}
                            </li>
                        </ul>
                    </li>

                    <li className="sheet-list__head hide-on-mobile">{t('@Support@')}</li>
                    <li className="sheet-list__section hide-on-mobile">
                        <ul>
                            <li className="sheet-list__item display-flex align-items-center cursor-pointer" onClick={()=>onClick(`${getAppCMSUrl()}/features?lang=${i18n.language}`)}>
                                <span className="flex-1 min-w-0">{t('@Features@')}</span>
                            </li>
                            <li className="sheet-list__item display-flex align-items-center cursor-pointer" onClick={()=>onClick(`${getAppCMSUrl()}/faq?lang=${i18n.language}`, '_blank')}>
                                <span className="flex-1 min-w-0">{t('@FAQ@')}</span>
                            </li>
                            <li className="sheet-list__item display-flex align-items-center cursor-pointer" onClick={()=>onClick(`${getServiceStatusUrl()}/service_status?lang=${i18n.language}`)}>
                                <span className="flex-1 min-w-0">{t('@System Status@')}</span>
                            </li>
                            <li className="sheet-list__item display-flex align-items-center cursor-pointer" onClick={()=>onClick(`${getQNAPUrl()}/${convertToQNAPLang(i18n.language)}/support-ticket/`)}>
                                <span className="flex-1 min-w-0">{t('@Contact us@')}</span>
                            </li>
                        </ul>
                    </li>

                    <li className="sheet-list__head hide-on-mobile">{t('@Community@')}</li>
                    <li className="sheet-list__section hide-on-mobile">
                        <ul>
                            <li className="sheet-list__item display-flex align-items-center cursor-pointer" onClick={()=>onClick(window.acc_mf.common.APP_FORUM_URL)}>
                                <span className="flex-1 min-w-0">{t('@Forum@')}</span>
                            </li>
                        </ul>
                    </li>

                    <li className="sheet-list__head hide-on-mobile">QNAP</li>
                    <li className="sheet-list__section hide-on-mobile">
                        <ul>
                            <li className="sheet-list__item display-flex align-items-center cursor-pointer" onClick={()=>onClick(`${getQNAPUrl()}/${convertToQNAPLang(i18n.language)}`)}>
                                <span className="flex-1 min-w-0">{t('@QNAP official website@')}</span>
                            </li>
                            <li className="sheet-list__item display-flex align-items-center cursor-pointer" onClick={()=>onClick(`${getPrivacyPolicyUrl()}`)}>
                                <span className="flex-1 min-w-0">{t('@Privacy policy@')}</span>
                            </li>
                            <li className="sheet-list__item display-flex align-items-center cursor-pointer" onClick={()=>onClick(`${getQNAPUrl()}/${convertToQNAPLang(i18n.language)}/before_buy/con_show.php?op=showone&cid=15`)}>
                                <span className="flex-1 min-w-0">{t('@Terms of service@')}</span>
                            </li>
                            <li className="sheet-list__item display-flex align-items-center cursor-pointer" onClick={()=>onClick(`${getAppCMSUrl()}/security?lang=${i18n.language}`)}>
                                <span className="flex-1 min-w-0">{t('@Security Disclaimer@')}</span>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>

            {switchWarning && <RegionSwitchWarning showModal={switchWarning} closeModal={closeRegionSwitchWarning} mode="switch_region" submitAction={switchRegion} switchTo={switchToRegion}/>}
            {/*{regionNotMatchWarning && <RegionSwitchWarning showModal={regionNotMatchWarning} closeModal={closeRegionMismatchWarning} submitAction={onClickPreferredRegion} mode="region_mismatch"/>}*/}
        </div>
    );
}

export default MainLevelPanel;